const baseOrigin = '/api';
// const baseOrigin = '//192.168.3.109:8082';

export {
    baseOrigin
}
